"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var withTheme_1 = require("../utils/withTheme");

var VolumeIcon_1 = require("./icons/VolumeIcon");

var handleClick = function handleClick(e, props) {
  e.preventDefault();
  props.controller && props.controller.unMute();
  props.onUnmute();
};

var handleTouchEnd = function handleTouchEnd(e, props) {};

var handleMouseDown = function handleMouseDown(e) {
  // Prevent focus on mouse down
  e.preventDefault();
};

var MutedUi =
/** @class */
function (_super) {
  __extends(MutedUi, _super);

  function MutedUi(props) {
    return _super.call(this, props) || this;
  }

  MutedUi.prototype.render = function () {
    var _this = this;

    return withTheme_1.withTheme(this.context.theme, 'start-muted-button')(React.createElement("button", {
      onClick: function onClick(e) {
        handleClick(e, _this.props);
      },
      onMouseDown: handleMouseDown,
      onTouchEnd: function onTouchEnd(e) {
        return handleTouchEnd(e, _this.props);
      },
      title: "Sl\xE5 p\xE5 ljud"
    }, React.createElement(VolumeIcon_1.VolumeOffIcon, null)));
  };

  MutedUi.contextTypes = {
    theme: PropTypes.object
  };
  return MutedUi;
}(React.Component);

exports["default"] = MutedUi;